<!--
  菜单
  Lovi 2020-06-03
-->
<template>
  <div>
    <van-tabbar v-model="active" :border="false">
      <van-tabbar-item :to="{ path: '/bill' }" replace>
        <i slot="icon" class="bill"></i>
        {{ $t("common.bill") }}
      </van-tabbar-item>
      <van-tabbar-item :to="{ path: '/statistics' }" replace>
        <i slot="icon" class="statistics"></i>
        {{ $t("common.statistics") }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
const TOPATH = ["bill", "statistics"];
export default {
  components: {},
  data() {
    return {
      active: 0
    };
  },
  created() {
    let path = this.$route.path.substring(1);
    this._showNavChane(path);
  },
  mounted() {},
  computed: {},
  methods: {
    _showNavChane(path) {
      this.active = TOPATH.indexOf(path);
    }
  },
  watch: {
    $route(to) {
      // 路由方式变化
      let path = to.path.substring(1);
      this._showNavChane(path);
    }
  }
};
</script>

<style lang="less" scoped>
.van-tabbar {
  height: 50px;
  background: #fff;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.1);

  &.van-hairline--top-bottom::after {
    content: normal;
  }

  .van-tabbar-item {
    color: #4a4a4a;

    /deep/.van-tabbar-item__icon {
      width: 100%;
    }

    i {
      width: 24px;
      height: 24px;
      display: block;
      margin: 0 auto;
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: 100%;

      &.bill {
        background-image: url("~@/assets/images/wallet/icon_bill_nor@2x.png");
      }

      &.statistics {
        background-image: url("~@/assets/images/wallet/icon_statistics_nor@2x.png");
      }
    }

    &.van-tabbar-item--active {
      color: #2042ab;

      i {
        &.bill {
          background-image: url("~@/assets/images/wallet/icon_bill_sel@2x.png");
        }

        &.statistics {
          background-image: url("~@/assets/images/wallet/icon_statistics_sel@2x.png");
        }
      }
    }
  }

  /deep/.van-icon {
    font: 1.5rem/1 "vant-icon";
  }
}
</style>
